var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNigeriaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1575_51402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6087 12.6885H14.4535C14.7391 12.6885 14.9707 12.457 14.9707 12.1714V2.86102C14.9707 2.57526 14.7391 2.34375 14.4535 2.34375H0.487977C0.202218 2.34375 -0.0292969 2.57538 -0.0292969 2.86102V12.1714C-0.0292969 12.457 0.202218 12.6885 0.487977 12.6885H11.6087Z",
    fill: "#4C8056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62594 2.34375V12.6885H0.487977C0.202561 12.6877 -0.0284958 12.4567 -0.0292969 12.1714V2.86102C-0.0284958 2.57561 0.202561 2.34455 0.487977 2.34375H4.62594Z",
    fill: "#4C8056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.625 2.34375H10.3147V12.6885H4.625V2.34375Z",
    fill: "#E6E7E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1575_51402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeriaFlag);
export default __webpack_public_path__ + "static/media/nigeria_flag.6ed2889a88e12b47fa256e5cbb2b2448.svg";
export { ForwardRef as ReactComponent };